import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import type { ConversationMessage } from "#types/types.ts";
import { type ColorValue, Flex, Text, useColorSchemeValue } from "@hopper-ui/components";
import { TipIcon } from "@hopper-ui/icons";

interface Props {
    message: ConversationMessage;
}

export const AssistantMessageMemoryUpdated = ({ message: { isMemoryUpdated } }: Props) => {
    const { tShared } = useSharedTranslation();

    const backgroundColor = useColorSchemeValue(
        "var(--wai-assistant-message-background-color)",
        "var(--wai-assistant-message-background-color)"
    );

    const textColor = useColorSchemeValue(
        "status-option2",
        "samoyed"
    ) as ColorValue;

    if (!isMemoryUpdated) {
        return null;
    }

    return (
        <Flex
            alignItems="center"
            gap="inline-sm"
            fontSize="body-sm"
            paddingY="inset-xs"
            paddingX="inset-md"
            borderRadius="rounded-lg"
            color={textColor}
            UNSAFE_backgroundColor={backgroundColor}
            className="wai-assistant-message-memory-updated"
            width="fit-content"
        >
            <TipIcon size="sm" />
            <Text size="sm">{tShared("memoryUpdated")}</Text>
        </Flex>
    );
};
